export const FETCH_CARRIER_USERS =  "FETCH_CARRIER_USERS"
export const FETCH_ACTIVE_CARRIER_USERS =  "FETCH_ACTIVE_CARRIER_USERS"
export const FETCH_ACTIVE_DRIVERS =  "FETCH_ACTIVE_DRIVERS"

